var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.list},[_c('ul',_vm._l((_vm.data),function(el,index){return _c('li',{key:index},[_c('span',[_vm._v(_vm._s(el.date))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(el.title))])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }